import { render, staticRenderFns } from "./IpoPortfolio.vue?vue&type=template&id=2462f20c&scoped=true"
import script from "./IpoPortfolio.vue?vue&type=script&lang=js"
export * from "./IpoPortfolio.vue?vue&type=script&lang=js"
import style0 from "./IpoPortfolio.vue?vue&type=style&index=0&id=2462f20c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2462f20c",
  null
  
)

export default component.exports